import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: null,
})
export class CreatJsonService {

    getAttributes(columns: any) {
        var names = columns.map((item: any) => {
          return item['name'];
        });
        return names;
      }

      createJsonFromControl(group: any, names: Array<string>, columns: any) {
        return names.reduce((prev, current) =>
          prev + "\"" + current + "\"" + ": " +
          `${columns.find((item: any) => item.name === current)!.type == "number" ? group.value[current] :
          columns.find((item: any) => item.name === current)!.type == "date" ? "\"" + group.value[current].format("YYYY-MM-DD") + "\"" :
           "\"" + group.value[current] + "\""}`
          + ", ", "{").slice(0, -2) + "}";
      }
}
